const getFetchOperatorsAlertsRequestState = (state) => {
  return state.main.operatorAlertState.fetchOperatorsAlertsRequestState
}
const getOperatorsAlerts = (state) => {
  return state.main.operatorAlertState.operatorsAlerts
}
const getOperatorsAlertsPaginationOffset = (state) => {
  return state.main.operatorAlertState.operatorsAlertsPaginationOffset
}

const getOperatorAlertFilter = (state) => {
  return state.main.operatorAlertState.operatorAlertFilter
}
const getClickedOperatorAlert = (state) => {
  return state.main.operatorAlertState.clickedOperatorAlert
}
const getAlertChargePoints = (state) => {
  return state.main.operatorAlertState.alertChargePoints
}
const getAlertChargePointsPaginationOffset = (state) => {
  return state.main.operatorAlertState.alertChargePointsPaginationOffset
}
const getAlertChargePointsFilter = (state) => {
  return state.main.operatorAlertState.alertChargePointsFilter
}
const getFetchAlertChargePointsRequestState = (state) => {
  return state.main.operatorAlertState.fetchAlertChargePointsRequestState
}
const getEditAlertRequestState = (state) => {
  return state.main.operatorAlertState.editAlertRequestState
}
const getDeleteAlertRequestState = (state) => {
  return state.main.operatorAlertState.deleteAlertRequestState
}
const getCreateAlertRequestState = (state) => {
  return state.main.operatorAlertState.createAlertRequestState
}

const getFetchAlertCountRequestState = (state) => {
  return state.main.operatorAlertState.fetchAlertCountRequestState
}
const getAlertCount = (state) => {
  return state.main.operatorAlertState.alertCount
}
const OperatorAlertsSelectors = {
  getFetchOperatorsAlertsRequestState,
  getOperatorsAlerts,
  getOperatorsAlertsPaginationOffset,
  getOperatorAlertFilter,
  getClickedOperatorAlert,
  getAlertChargePoints,
  getAlertChargePointsPaginationOffset,
  getAlertChargePointsFilter,
  getFetchAlertChargePointsRequestState,
  getEditAlertRequestState,
  getDeleteAlertRequestState,
  getCreateAlertRequestState,
  getFetchAlertCountRequestState,
  getAlertCount,
}

export default OperatorAlertsSelectors
